<template>
  <div>
    <el-row :gutter="20" class="top-block">
      <Breadcrumb :route="this.$route"></Breadcrumb>
    </el-row>
      <!-------------------------------------------------------------------->
      <!-- action -->
      <!-------------------------------------------------------------------->

    <el-row v-if="!editTask">   
      <el-col :xs="8" :sm="8" :lg="8">
          <el-button type="normal" @click.prevent="goBack" class="ml-20" circle><i class="el-icon-d-arrow-left"></i>
          </el-button>
        </el-col>
        <el-col :xs="16" :sm="16" :lg="16" style="text-align: right">
        <el-button v-if="canEdit" type="warning" @click.prevent="handleDraft">暫存 <i
            class="el-icon-s-claim"></i></el-button>
        <el-button v-if="canEdit" type="primary" @click.prevent="handleSign" class="mr-20">送簽核 <i
            class="el-icon-s-claim"></i></el-button>
      </el-col>
    </el-row>

      <!-------------------------------------------------------------------->
      <!-- form -->
      <!-------------------------------------------------------------------->


      <!--    基本資料-->
    <el-row v-if="!editTask">  
      <el-col :xs="24" :sm="24" :lg="24" class="mt-20">
        <el-main>
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>基本資料</span>
              <el-button style="float: right; padding: 2px 0; margin-top: -12px" type="text"><el-tag type="success">{{basicForm.status | fmtSignResult }}</el-tag></el-button>
            </div>
            <div>
              <el-form :model="basicForm" :rules="rules" ref="basicDataForm" >
                <el-row>
                  <el-col :xs="12" :sm="12" :md="12">
                    <p>填單人: {{basicForm.userObj.username}} </p>
                  </el-col>
                  <el-col :xs="12" :sm="12" :md="12">
                    <p>報表日期: {{basicForm.startDate | fmtDate}}</p>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :xs="24" :sm="24" :md="24">
                    <p class="mt-20">標題: {{basicForm.title}} </p>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </el-card>
        </el-main>
      </el-col>
    </el-row>

      

      <!-------------------------------------------------------------------->
      <!-- table -->
      <!-------------------------------------------------------------------->

      <!--    工作項目資料-->
      <el-row v-if="!editTask">
        <el-col :xs="24" :sm="24" :lg="24" class="mt-20">
          <el-main class="taskMain">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>工作項目資料</span>
                <el-button v-if="canEdit" style="float: right; padding: 5px 12px" 　type="primary"
                           @click.prevent="handleAddTask" class="mr-20" id="add_task_btn">新增工作紀錄 <i class="el-icon-s-claim"></i></el-button>
              </div>
              <div>

                <el-table :data="task.tableData" empty-text="無資料" stripe  :default-expand-all="true">
                  <el-table-column label="項次" width="50">
                    <template slot-scope="scope">{{scope.$index+1}}</template>
                  </el-table-column>
                  <el-table-column label="項目" prop="taskTypeName">
                  </el-table-column>
                  <el-table-column label="" type="expand" >
                    <template slot-scope="scope">
                    <p class="mt-10 ml-10">內容 : 
                      <div v-html="fmtNotes(scope.row.notes)" class="mynotes ml-10 mt-10"></div>
                    </p>

                    <p class="mt-10 ml-10">花費時長:  {{scope.row.timeHour}} 時 {{scope.row.timeMinute}}分鐘</p>



                    <ol class="ml-10">
                      <li v-for="f in scope.row.fileListDisplay" :key="f.id" class="mt-10">
                        <el-button v-if="isImage(f.fileRepo.name)" type="text" 
                          @click="showImage(f.fileRepo.uuid)"> ({{f.fileNote}}) {{f.fileRepo.name}}
                        </el-button>
                        <p style="display:inline-block;" v-else>({{f.fileNote}}) <a :href="displayAvatar(f.fileRepo.uuid)" target=_new>
                          {{f.fileRepo.name}}
                        </a></p>

                        <el-popconfirm
                          class="ml-10 popconfirm-bg"
                          title="確定刪除此筆附件嗎?"
                          confirm-button-text="確定"
                          cancel-button-text="取消刪除"
                          icon="el-iconf-info"
                          icon-color="red"
                          @confirm="deleteFile(f.id)">
                          <el-button v-if="canEdit" type="text" slot="reference" ><i class="el-icon-error"></i> 刪除</el-button>
                        </el-popconfirm>
                      </li>
                    </ol>        


                    
                  </template>
                  </el-table-column>
                  
                  <el-table-column label="操作" width="120" v-if="canEdit">
                    <template slot-scope="scope">
                    
                      <el-button type="primary" circle @click="handleTaskEdit(scope.row)"><i class="el-icon-edit"></i></el-button>

                      <el-popconfirm
                          class="ml-10 popconfirm-bg"
                          title="確定刪除此筆資料嗎?"
                          confirm-button-text="確定"
                          cancel-button-text="取消刪除"
                          icon="el-iconf-info"
                          icon-color="red"
                          @confirm="taskHandleDeleteHistory(scope.row.id)"
                      >
                        <el-button type="danger" slot="reference" circle><i class="el-icon-delete"></i></el-button>
                      </el-popconfirm>
                    </template>
                  </el-table-column>
                </el-table>

               
              </div>
            </el-card>
          </el-main>
        </el-col>
      </el-row>

      <!--    簽核紀錄-->
      <SignOffHistory :editMode="editTask" :canViewSignOff="canViewSignOff"></SignOffHistory>

    


      <!-------------------------------------------------------------------->
      <!-- dialog -->
      <!-------------------------------------------------------------------->

      <el-row v-if="editTask" style="background-color: white; padding:20px">
      
        <el-form class="myform" label-position="top" :model="task.form" ref="taskForm" :rules="taskFormRule" id="taskForm">
          <el-row>
            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item label="項目標題" prop="taskType">
                <el-input placeholder="請輸入標題" v-model="task.form.taskType" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item label="說明" prop="notes">
                <el-input type="textarea" :rows="3" placeholder="請輸入說明" v-model="task.form.notes"
                          autocomplete="off"></el-input>
                <!-- <vue-editor v-model="task.form.notes" :editorToolbar="myToolbar"></vue-editor>        -->
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item label="花費時長" prop="timeHour">
                  <el-input-number v-model="task.form.timeHour"  :min="0" :max="40"></el-input-number> 小時
              </el-form-item>
              <el-form-item label="" prop="timeMinute">
                  <el-input-number v-model="task.form.timeMinute"  :min="0" :max="59" class="mt-10"></el-input-number> 分鐘
              </el-form-item>
              
            </el-col>
          </el-row>

          <el-row v-for="(btn, i) in task.btnCount" :key="i" style="background-color: #f4f4f5; padding: 8px; margin-top: 8px;">
          <el-col :xs="12" :sm="12" :md="12" class="pr-10">
            <el-form-item label="檔案備註">
              <el-input placeholder="檔案備註" v-model="task.form.fileNotes[i]" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" >
            <el-form-item label="附件">
              <el-upload
                  :multiple="false"
                  class="upload-demo"
                  action="/api/file/upload"
                  :on-success="taskHandleUploadSuccess"
                  :before-upload="beforeUpload"
                  :on-remove="taskHandleFileRemove">
                <el-button size="small" type="primary">上傳文件</el-button>
                <div slot="tip" class="el-upload__tip">限上傳 5M 以下的文件</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>

          
          <el-row class="mb-20 mt-20">
            <el-col :xs="24" :sm="24" :md="24">
              <el-button size="small" type="primary" @click="taskNewUploadField()">新增上傳</el-button>
            </el-col>
          </el-row>

        </el-form>

        <div  style="float: right;" class="mt-20">
          <el-button @click="cancelAddTask">取 消</el-button>
          <el-button type="primary" @click="taskFormSave('taskForm')">確 定</el-button>
        </div>
      </el-row>


      <el-row>
        <el-dialog title="附件圖"
                   :visible.sync="img.dialog"
                   :width="dw">
            <div class="demo-image">
              <el-image
                style="width: 100%; max-width: 100%; height: 100%;"
                :src="img.url"
                fit="cover" lazy>
                  <div slot="placeholder" class="image-slot">
              <i class="el-icon-loading"></i> 開啟中...
            </div>
                </el-image>
            </div>
         </el-dialog>
      </el-row>

     
  </div>
</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Breadcrumb";
import SignOffHistory from '@/components/signoff/sign-history'
import {mapState} from 'vuex'
import debounce from 'lodash/debounce'
import dayjs from "dayjs";
import {VueEditor} from 'vue2-editor'

export default {
  name: "TodoDetailOa",
  components: {
    Breadcrumb, SignOffHistory,VueEditor
  },
  data() {
    let checkName = (rule, value, callback) => {
      if (value === '' || value === null || typeof value === 'undefined') {
        callback(new Error('請輸入資料'))
      } else {
        callback()
      }
    }
    let treeCheck = (rule, value, callback) => {
      let selectedIds = this.$refs.tree.getCheckedKeys();

      if (!selectedIds || selectedIds.length === 0) {
        callback(new Error('請確認出勤前工作'))
      } else {
        callback()
      }
    }

    return {
      editTask: false,
      
      img:{
        dialog: false,
        url:''
      },

      props: {
        label: 'name'
      },
      historyTableData: [],
      precheckListOption: [],

      basicForm: {
        id: '',
        title: '',
        startDate: '',
        userObj: {
          username:''
        },
        status:'',
        endDate: '',
        preCheckItem: '',
        preCheckTree:[],
        visitRoute: ''
      },

      visitForm: {
        customerId: '',
        arrivalTime: '',
        deliveryContent: [],
        serviceContent: [],
        paymentReceive: [],
        notes: '',
        fileList: []
      },

      task: {
        tableData:[],
        dialog: false,
        form: {
          mytodoId: '',
          id:'',
          fileList:[],
          fileNotes:[],
          timeHour:0,
          timeMinute:0,
          notes:''
        },
        btnCount:0,
        taskTypeOptions:[]
      },

      loading: false,
      dw: '40%',
      fileList: [],
      preCheckOption: [],
      precheckList: [],
      tableData: [],
      options: [],
      queryField: '',
      keyword: '',
      pageNum: 1,
      pageSize: 10,
      total: 0,
      dialogFormVisible: false,
      formLabelWidth: '',
      deliveryContentOptions: ['送店', '指送'],
      shippingToDifferentAddress: false,
      serviceContentOptions: ['補目錄', '做宣傳', '交流','收退料', '放帳單'],
      paymentReceiveOptions: ['現金', '期票'],
      btnCount: 0,

      form: {
        mytodoId: '',
        custId: '',
        arrivalTime: '',
        deliveryContentChecked: [],
        deliveryAddress:'',
        deliveryContent: '',
        serviceContentChecked: [],
        serviceContent: '',
        paymentReceiveChecked: [],
        paymentReceive: '',
        notes: '',
        fileList: [],
        fileNotes: [],
        custLabel:'',
        discountType:''
      },
      myToolbar:[
          ["link"]
      ],
      rules: {
        title: [{validator: checkName, trigger: 'change'}],
        startDate: [{validator: checkName, trigger: 'change'}]
      },
      visitRules: {
        notes: [{required:true, validator: checkName, trigger: 'change'}]
      },
      visitFormRules: {
        custId: [{required: true, validator: checkName, trigger: 'change'}],
        arrivalTime: [{required: true, validator: checkName, trigger: 'change'}],
        customerRecord: [{required: true, validator: checkName, trigger: 'blur'}]
      },
      taskFormRule:{
        notes: [{required:true, validator: checkName, trigger: 'change'}],
        taskType: [{required:true, validator: checkName, trigger: 'change'}]
      }
    }
  },
  computed: {
    ...mapState('login', ['userInfo']),
    canEdit() {
      return this.basicForm.status === 'draft' || this.basicForm.status === 'reject'
    },

    canViewSignOff() {
      return this.basicForm.status === 'review' || this.basicForm.status === 'close'
    },
  },
  methods: {
    showImage(uuid) {
      this.img.dialog = true
      this.img.url = this.displayAvatar(uuid)
    },
    deleteFile(id) {
      this.request.delete("/todo/div-mgr/history/file/" + id).then(res => {
        if (res.code === '200') {
          this.taskLoadHistory()
          this.showResult('success', '附件刪除成功.')
        } else {
          this.showResult('error', '附件刪除失敗.')
        }
      })
    },
    clearInputForm() {
      this.$refs['taskForm'].resetFields()
    },
    cancelAddTask() {

      this.clearInputForm()
      this.editTask = false
      this.$nextTick(()=>{
        document.getElementById("add_task_btn").scrollIntoView({behavior: 'smooth', inline:'nearest'})
      })

      // this.editTask = false
      // this.$refs['taskForm'].resetFields()
      // this.$nextTick(()=>{
      //   document.getElementById("add_task_btn").scrollIntoView({behavior: 'smooth', inline:'nearest'})
      // })

    },
    
    querySearch(str, cb){
      this.request.get("/customer/q?keyword=" + str).then(res => {
        if (res.code === '200') {
          let list = res.data.map((item) => {
            return {
              value: item.company + "(" + item.name + ")",
              id: item.id 
            }
          })
          cb(list)
        }
      })
    },
    handleSelect(item) {
      this.form.custId = item.id
    },
    loadCustomerHistoryData() {
      this.request.get("/todo/customer/history/" + this.form.mytodoId).then(res => {
        if (res.code === '200') {
          this.tableData = res.data
        } else {
          this.showResult('error', '客戶拜訪紀錄撈取失敗')
        }
      })
    },
    loadJobSignHistory() {
      this.request.get("/job/signoff/history/" + this.form.mytodoId).then(res => {
        if (res.code === '200') {
          this.historyTableData = res.data
        } else {
          this.showResult('error', '客戶拜訪簽核紀錄撈取失敗')
        }
      })
    },
    async saveData(formName) {
      this.$refs[formName].validate(async valid => {
        console.log('this.form:', this.form)
        if (valid) {
          try {
            await this.$store.dispatch('todo/saveMytodo', this.form)

            this.showResult('success', '資料更新成功.')

            await this.loadCustomerHistoryData()
            this.dialogFormVisible = false

          } catch (e) {
            this.showResult('success', '資料更新失敗')
          }
        }
      })
    },
    handleSubmitForm() {
      this.request.post("/todo", this.basicForm).then(res => {
        //console.log(res)
        if (res.code === '200') {
          this.formDefault()
          this.showResult('success', '資料更新成功.')
        } else {
          this.showResult('error', '資料更新失敗.')
        }
      })
    },
    handleTaskEdit(rowData) {
      console.log("edit:", rowData)
      this.editTask = true
      this.task.form = rowData
      this.task.form.fileList = []
      this.task.form.fileNotes = []
      this.task.btnCount = 0
    },

    handleDraft() {
      this.handleSubmitForm()
    },
    handleSign() {
      this.$confirm('資料填寫已完成，按下「確定」後將呈主管簽核?', '提醒', {
            confirmButtonText: '確定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.basicForm.status = "review"
            this.request.post("/todo/signoff", this.basicForm).then(res => {
              if (res.code === '200') {
                this.showResult('success', '表單送簽核成功')
                this.$nextTick(()=>{
                    this.goBack()
                 })
              } else {
                this.showResult('error', '表單送簽核失敗')
              }
            })
          }).catch(() => {

          });
    },
    handleAdd() {
      this.dialogFormVisible = true
      this.form.id = null
      this.form.fileList = []
      this.form.fileNotes = []
      this.btnCount = 0
    },

    handleAddTask() {

      
      this.task.form.id = null
      this.task.form.fileList = []
      this.task.form.fileNotes = []
      this.task.btnCount = 0

      this.editTask = true
      this.$nextTick(()=>{
              
        document.getElementById("taskForm").scrollIntoView({behavior: 'smooth', inline:'nearest'})
      })

      
    },  
    handleEdit(rowData) {
      this.dialogFormVisible = true
      this.form = rowData
    },
    handleDelete(id) {
      this.request.delete("/todo/customer/history/" + id).then(res => {
        if (res.code === '200') {
          this.showResult('success', '資料刪除成功.')
          this.loadCustomerHistoryData()
        } else {
          this.showResult('error', '資料刪除失敗.')
        }
      })
    },
    

    closeDialog() {
      this.form.notes = ''
      this.$refs['visitForm'].resetFields()
      //this.loadCustomerHistoryData()
    },
    closeTaskDialog() {
      //this.task.form.notes = ''
      this.$refs['taskForm'].resetFields()
      this.task.btnCount = 0
      //this.loadCustomerHistoryData()
    },
    setDialogWidth() {
      let windowSize = document.body.clientWidth;
      const defaultWidth = 400; // 預設寬度
      if (windowSize < defaultWidth) {
        this.dw = "90%";
      } else {
        this.dw = "40%";
      }
    },
    formDefault() {
      this.request.get("/todo/" + this.form.mytodoId).then(res => {
        if (res.code === '200') {
          this.basicForm = res.data

          if (res.data.preCheckItem !== '') {
            this.precheckListOption = res.data.preCheckItem.split(",")
          }
          // this.basicForm.title = res.data.title
          // this.basicForm.startDate = res.data.startDate
          // this.basicForm.endDate = res.data.endDate
        } else {
          this.showResult('error', '撈資料失敗')
        }
      })
      this.form.userId = this.userInfo.id
      this.form.todoType = this.getTodoType()
    },
    getTodoType() {
      this.userInfo.id;
    },
    loadPreCheckItem() {
      let req = '/dic/type?queryField=pre_check'
      this.request.get(req).then(res => {
        if (res.code === '200') {
          this.preCheckOption = res.data
        }
      })
    },
    goBack() {
      this.$router.push('/daily/todo')
    },
    handleUploadSuccess(res, file) {
      this.form.fileList.push(res.uuid)
    },
    
    
    handleFileRemove(file, fileList) {
      this.form.fileList = this.form.fileList.filter(e => e !== file.response.uuid)
    },
    beforeUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      return isLt5M
    },
    saveCustomerVisit(formName) {
      this.$refs[formName].validate(async valid => {
        console.log('valid:', valid)
        if (valid) {
          try {
            //將陣列轉換成後台可以接的字串
            this.form.deliveryContent = this.form.deliveryContentChecked.join(",")
            this.form.serviceContent = this.form.serviceContentChecked.join(",")
            this.form.paymentReceive = this.form.paymentReceiveChecked.join(",")
            this.request.post("/todo/customer/history", this.form).then(res => {
              if (res.code === '200') {
                this.dialogFormVisible = false
                this.loadCustomerHistoryData()
                this.showResult('success', '更新成功')
              } else {
                this.showResult('error', res.message)
              }
            })

          } catch (e) {
            this.showResult('error', '資料更新失敗')
          }
        }
      })

    },
    loadMyCustomer() {
      this.request.get("/customer/query1?keyword=&all=y").then(res => {
        if (res.code === '200') {
          this.options = res.data
        } else {
          this.options = ['查無負責的客戶名稱']
        }
      })
    },
    newUploadField() {
      this.btnCount++
    },
    
    loadTaskType() {
      let req = '/dic/type?queryField=sales_manager_task'
      this.request.get(req).then(res => {
        if (res.code === '200') {
          this.task.taskTypeOptions = res.data
        }
      })
    },

    taskLoadHistory() {
      this.request.get("/todo/div-mgr/history/" + this.task.form.mytodoId).then(res => {
        if (res.code === '200') {
          this.task.tableData = res.data
        } else {
          this.showResult('error', '工作項目紀錄撈取失敗')
        }
      })
    },
    taskHandleUploadSuccess(res, file) {
      this.task.form.fileList.push(res.uuid)
    },
    taskNewUploadField() {
      this.task.btnCount++
    },
    taskHandleFileRemove(file, fileList) {
      this.task.form.fileList = this.task.form.fileList.filter(e => e !== file.response.uuid)
    },
    taskFormSave(formName){
      this.$refs[formName].validate(async valid => {
        if (valid) {
          try {
            this.request.post("/todo/div-mgr/history", this.task.form).then(res => {
              if (res.code === '200') {
                
                this.clearInputForm()
                this.editTask = false
                this.showResult('success', '新增成功')
                this.$nextTick(()=>{
                  this.taskLoadHistory()
                  document.getElementById("add_task_btn").scrollIntoView({behavior: 'smooth', inline:'nearest'})
                })
              } else {
                this.showResult('error', res.message)
              }
            })

          } catch (e) {
            this.showResult('error', '資料更新失敗')
          }
        }
      })
    },
    taskHandleDeleteHistory(id) {
      this.request.delete("/todo/div-mgr/history/" + id).then(res => {
        if (res.code === '200') {
          this.taskLoadHistory()
          this.showResult('success', '資料刪除成功.')
        } else {
          this.showResult('error', '資料刪除失敗.')
        }
      })
    },


  },
  filters: {
    signResult(value) {
      if (value === 'N') return '退回'
      if (value === 'Y') return '同意'
      if (value === 'cancel') return '取消'
    }
  },
  mounted() {
    this.form.mytodoId = this.$route.params.mytodoId
    this.task.form.mytodoId = this.$route.params.mytodoId


    //this.loadJobSignHistory()

    //設定一些欄位預設值
    this.formDefault()


    this.taskLoadHistory()

    this.loadTaskType()

    this.setDialogWidth();
  }
}
</script>

<style scoped>
.el-table {
  border-radius: 10px;
  padding: 20px;
}

.el-table >>> .headerStyle {
  /*background-color: #1e8fc6;*/
}

.el-popover.el-popper .el-popconfirm {
  background-color: black !important;
  padding: 10px !important;
}

.avatar-uploader {
  /*border: 1px dashed #d9d9d9;*/
  /*border-radius: 6px;*/
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-bottom: 20px;
  text-align: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.display-avatar {
  width: 60px;
  height: 60px;
  border-radius: 999px;
}


/deep/ .el-upload-dragger {
  width: 180px !important;
}

.myform >>> .el-form-item__label {
  padding: 0;
}

.el-main {
  padding: 0;
}
.el-form-item {
  margin-bottom: 12px;
}

.taskMain >>> .el-card__body {
  padding: 0 4px;
}
.el-table {
  padding: 0;
}

.el-form--label-top .el-form-item__label {
  padding: 0;
}
.el-autocomplete {
  width: 100%;
}
.el-card__body {
  padding: 0px 10 !important;
}
.mynotes  {
  line-height: 24px;
  font-size: 15px;
}

</style>
